import { transactionToPromise } from './transactionToPromise';
import { type Logger, type TransactionsWithCommit } from './types';

// Not available on older browsers https://developer.mozilla.org/en-US/docs/Web/API/IDBTransaction/commit
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const commitTransaction = (
	transaction: TransactionsWithCommit,
	logger: Logger,
): Promise<void> => {
	try {
		if (typeof transaction.commit === 'function') {
			transaction.commit();
		}
	} catch (error) {
		logger.error('Failed to force commit transaction:', error);
		throw error;
	}
	return transactionToPromise(transaction);
};
